import React from 'react'
// import Container from 'react-bootstrap/Container';
import Carousel from 'react-bootstrap/Carousel';

import { HlzSlideArray } from "../assets/HlzSlideArray";
import "./HlzSlide.css";

export function HlzSlide() {
  return (
    <section id='hlzslide' className='hlzslide-block'>
      {/* <Container fluid> */}
        {/* <div className='title-holder'> */}
        <h2 className='text-center text-success'>---Company Introduction Slide---</h2>
        {/* </div> */}
        <Carousel controls={true}> {
          HlzSlideArray.map(slide => {
            return (
              <Carousel.Item key={slide.id}>
                <div className='subtitle text-center'><h3>{slide.text}</h3></div>
                <img src={slide.image} className='d-block' alt={slide.id} />
                {/* <img src={slide.image}  className='d-block' style={{ height: '75vh' }} alt={slide.id} /> */}
                <Carousel.Caption>
                  <blockquote>
                    {/* <p><h3>{slide.text}</h3></p> */}
                    <cite>
                      <span className='title'><h3>{slide.title}</h3></span>
                      {/* <span className='designation'><h4>{slide.designation}</h4></span> */}
                    </cite>
                  </blockquote>
                </Carousel.Caption>
              </Carousel.Item>
            );
          })
        } </Carousel>
      {/* </Container> */}
    </section>
  );
}

export default HlzSlide;